import { GetLomdaResponseType } from "../hooks/useGetLomda";
import GeneralTab from "./tabs/general";
import Image from "next/image";
import LomdaSceneLayout from "@/features/lomdaEditor/components/layout/lomdaSceneLayout";
import { LomdaContent, LomdaMetadata } from "@/lib/utils/lomda/types";

export default function LomdaSheetMain({
    lomda,
}: {
    lomda: GetLomdaResponseType["data"];
}) {
    const content = lomda?.content
        ? (JSON.parse(lomda.content) as LomdaContent)
        : null;
    const metadata = lomda?.metadata
        ? (JSON.parse(lomda.metadata) as LomdaMetadata)
        : null;
    const logoUrl = metadata?.logoUrl;
    return (
        <main className="flex flex-1 flex-col py-4 px-8 gap-4">
            <div className="relative aspect-video rounded-md border">
                {content && content.scenes.length > 0 ? (
                    <LomdaSceneLayout
                        scene={content.scenes[0]}
                        logoUrl={logoUrl}
                    />
                ) : (
                    <Image
                        className="rounded-md"
                        src={
                            lomda.thumbnailUrl ||
                            "/images/image-placeholder.png"
                        }
                        fill
                        alt="Lomda thumbnail"
                    />
                )}
            </div>
            <GeneralTab lomda={lomda} />
            <div className="pb-8" />
        </main>
    );
}
